import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { SEAMLESS_REGISTRATION_ACTION_TYPE } from "./seamless-registration.action";
import {
	SeamlessRegistrationPayload,
	SeamlessRegistrationReferenceResponse,
	SeamlessRegistrationResponse,
	SeamlessRegistrationState,
} from "./seamless-registration.model";

const INITIAL_STATE: SeamlessRegistrationState = {};

export function seamlessRegistrationReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): SeamlessRegistrationState {
	switch (action.type) {
		case SEAMLESS_REGISTRATION_ACTION_TYPE.initializeRegistrationSuccess: {
			const { registrationReference, customerReference, hashedEmail } =
				action.payload as SeamlessRegistrationReferenceResponse;
			return updateState(state, {
				registrationReference,
				customerReference,
				hashedEmail,
			});
		}

		case SEAMLESS_REGISTRATION_ACTION_TYPE.getRegistrationStateSuccess: {
			const payload = action.payload as SeamlessRegistrationResponse;
			return updateState(state, {
				providerUrl: payload.providerUrl,
				status: payload.status,
				customerRegistrationStatus: payload.customerRegistrationStatus,
			});
		}

		case SEAMLESS_REGISTRATION_ACTION_TYPE.initializeRegistration: {
			const { country } = action.payload as SeamlessRegistrationPayload;
			return updateState(state, {
				country,
			});
		}

		case SEAMLESS_REGISTRATION_ACTION_TYPE.resetSeamlessRegistration: {
			return INITIAL_STATE;
		}

		default:
			return state;
	}
}
